import { SolIcon } from '@sol/icons';
import { SolValidationType } from './sol-validation-type';
import { SolValidationMessage } from './sol-validation-message';
import { SolText } from './sol-text';
import { ObjectTools } from '../../tools/object-tools';
import { IconTools } from '../../tools/icon-tools';

export class SolAlert {
  private constructor(
    public readonly type: SolValidationType,
    public readonly messages: SolValidationMessage[],
    public readonly text: SolText,
    public readonly info: SolText | undefined,
    public readonly custom: boolean,
    public readonly inline: boolean,
    public readonly truncated: boolean,
    public readonly hostClass: string,
    public readonly icon: SolIcon | undefined,
  ) {}

  public static of(
    type: SolValidationType = 'error',
    text: SolText = SolText.empty(),
    messages: SolValidationMessage[] = [],
    custom: boolean = false,
    inline: boolean = false,
  ): SolAlert {
    return new SolAlert(type, messages, text, undefined, custom, inline, false, '', undefined).recalculate();
  }

  public withType(type: SolValidationType): SolAlert {
    return this.copy({ type }).recalculate();
  }

  public withMessages(messages: SolValidationMessage[]): SolAlert {
    const text = messages.length > 0 ? messages[0].text : SolText.empty();
    const type = messages.length > 0 ? messages[0].type : 'error';
    return this.copy({ messages, text, type }).recalculate();
  }

  public withText(text: SolText): SolAlert {
    return this.copy({ text });
  }

  public withInfo(info: SolText | undefined): SolAlert {
    return this.copy({ info });
  }

  public withCustom(custom: boolean): SolAlert {
    return this.copy({ custom });
  }

  public withInline(inline: boolean): SolAlert {
    return this.copy({ inline }).recalculate();
  }

  public withTruncated(truncated: boolean): SolAlert {
    return this.copy({ truncated });
  }

  private recalculate(): SolAlert {
    const hostClass =
      `sol-alert-container sol-alert-container-${this.type}` +
      (this.inline ? '' : ` sol-alert-container-${this.type}-background`);
    const icon = IconTools.fromValidationType(this.type);
    return this.copy({ hostClass, icon });
  }

  private copy(props: Partial<SolAlert>): SolAlert {
    return ObjectTools.copy<SolAlert>(this, props);
  }
}
